import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "help-content__summary" };
const _hoisted_2 = ["href"];
import { onMounted, ref } from 'vue';
import env from '../services/AppEnv';
import help from '../services/HelpRepository';
import trans from '../services/Translator';
import Icon from "./Icon.vue";
import Spinner from "./Spinner.vue";
import { useClickaway } from "../composables/clickaway";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Help',
    props: {
        code: {},
        position: {}
    },
    setup(__props) {
        const props = __props;
        const root = ref(null);
        const show = ref(false);
        const helpValue = ref(null);
        onMounted(() => useClickaway(root, hide));
        function toggle() {
            if (show.value) {
                show.value = false;
                return;
            }
            show.value = true;
            if (helpValue.value) {
                return;
            }
            help.get(props.code)
                .then(data => helpValue.value = data)
                .catch(() => helpValue.value = {
                code: props.code,
                summary: trans('errors.currently_unavailable'),
                hasMore: false,
            });
        }
        function hide() {
            show.value = false;
        }
        function available() {
            return help.isAvailable();
        }
        function helpUrl() {
            return `${env.docs.baseUrl}/help/${props.code}`;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "_help",
                ref_key: "root",
                ref: root
            }, [
                (available())
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "help-indicator",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (toggle()), ["prevent"]))
                    }, [
                        _createVNode(Icon, { name: "help" })
                    ]))
                    : _createCommentVNode("", true),
                _cache[5] || (_cache[5] = _createTextVNode()),
                (show.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["help-content", 'help-content--' + (__props.position ?? 'center')])
                    }, [
                        _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (hide()), ["prevent"])),
                            href: "",
                            class: "help-content__close"
                        }, [
                            _createVNode(Icon, { name: "close" })
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (helpValue.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_1, _toDisplayString(helpValue.value.summary), 1),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                (helpValue.value.hasMore)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: helpUrl(),
                                        class: "help-content__more",
                                        target: "_blank"
                                    }, _toDisplayString(_ctx.$t('more')) + "…\n                ", 9, _hoisted_2))
                                    : _createCommentVNode("", true)
                            ], 64))
                            : _createCommentVNode("", true),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createVNode(Spinner, {
                            loading: !_unref(help)
                        }, null, 8, ["loading"])
                    ], 2))
                    : _createCommentVNode("", true)
            ], 512));
        };
    }
});
